export default "__VITE_ASSET__9F6w_dVY__"